export default __webpack_public_path__ + "static/media/Efeso.4b4cf0c3.png";